import { Space, Row } from 'antd';
import { useContext, useMemo } from 'react';

import { VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsServicesSumLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);
  const Values = serverFilters.VisitsFilter?.[filterGroupIndex]?.Values?.[0];

  const memoizedMinServicesCost = useMemo(() => {
    return Values?.MinServicesCost;
  }, [Values]);

  const memoizedMaxServicesCost = useMemo(() => {
    return Values?.MaxServicesCost;
  }, [Values]);

  return (
    <Space
      className={`visits-services-sum-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>Сумма оказанных услуг</span>
      {(memoizedMinServicesCost !== null ||
        memoizedMaxServicesCost !== null) && (
        <Row>
          <ClientFilterTag
            filters={filters}
            serverFilters={serverFilters}
            filtersArea={VISITS_FILTER}
            filterGroupIndex={filterGroupIndex}
            setFilters={setFilters}
            setServerFilters={setServerFilters}
            valueKey={
              'MinServicesCost' as keyof NClientsList.VisitsFilterUnitValue['MinServicesCost']
            }
          >
            {`от ${memoizedMinServicesCost}`}
          </ClientFilterTag>
          <ClientFilterTag
            filters={filters}
            serverFilters={serverFilters}
            filtersArea={VISITS_FILTER}
            filterGroupIndex={filterGroupIndex}
            setFilters={setFilters}
            setServerFilters={setServerFilters}
            valueKey={
              'MaxServicesCost' as keyof NClientsList.VisitsFilterUnitValue['MaxServicesCost']
            }
          >
            {`до ${memoizedMaxServicesCost}`}
          </ClientFilterTag>
        </Row>
      )}
    </Space>
  );
};
